// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import { useCurrentScenarioId } from '../../../../state/hooks/ScenarioHooks';
import { useGetTechVar, useGetAgingLawsByScenario } from '../../../../state/wizard/WizardHooks';

export const useGestionEquipements = () => {
  const scenarioId = useCurrentScenarioId();
  const equipmentFamily = useGetTechVar('familleEquipement', scenarioId);
  const agingLaws = useGetAgingLawsByScenario(scenarioId);

  return {
    ageDistribution:
      agingLaws?.AgeDistribution?.find((ad) => ad.Identifiant === equipmentFamily)?.AgeDistribution || [],
    selectedFamily: equipmentFamily,
    isLoading: !agingLaws && equipmentFamily,
  };
};
